// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-G":"SHP2G_shp2-detail-G__Fhbo7"};